export default __webpack_public_path__ + "static/analysts_Architect_INTJ_weaknesses-27c5ad890361410cca94c0796c1d91bf.svg";